import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { MainLayoutProps } from "./main-layout-types";
import { ContentMain } from "./style-component";
import FloatMenu from "@/components/float-menu/float-menu";
import MenuBack from "@/components/menu-back/menu-back";
import { AlertNotification } from "@/components/alert-notification/alert-notification";
import { useUserContext } from "@/contexts/user/useUserContext";
import EnviromentAlertHeader from "@/components/enviroment-alert-header/enviroment-alert-header";
const NOT_APPLY_PADDING_TO_PATH = ['/', '/home', '/start', '/login', '/scanner'];
const NOT_SHOW_MENU_BACK = ['/', '/home', '/login', '/redeem-gift', '/scanner', '/register' ];
const NOT_SHOW_FLOAT_MENU = ['/login', '/redeem-gift', '/scanner', '/wallet/configuration', '/register', '/terms-and-conditions', '/privacy-policy'];

const MainLayout: React.FC<MainLayoutProps> = ({ children, variant = 'appBg', style }) => {
	const location = useLocation();
	const navigate = useNavigate();
	const { user } = useUserContext();
	const showByStatus = user?.status !== 2;

	const handleNavigate = (path: string) => {
		if (!path) return;
		navigate(path);
	}

	return (
		<>
		{import.meta.env.VITE_TEST_MODE === 'true' &&
			<EnviromentAlertHeader />
		}
		
		<ContentMain variant={variant} style={{
			...style,
			minHeight: '100vh',
			padding: NOT_APPLY_PADDING_TO_PATH.includes(location.pathname) ? '0px' : '32px 16px',
			paddingBottom: NOT_APPLY_PADDING_TO_PATH.includes(location.pathname) ? '0px' :'100px',
		}}>
			{!NOT_SHOW_FLOAT_MENU.includes(location.pathname) && showByStatus &&
				<>
					<AlertNotification />
					<FloatMenu orientation='vertical' handleClick={handleNavigate} />
				</>

			}
			{!NOT_SHOW_MENU_BACK.includes(location.pathname) && showByStatus && (
				<MenuBack />
			)}
			{children ?? <Outlet />}
		</ContentMain>
	</>
	)
};

export default MainLayout;